import React from "react";
import LegalPage from "@/pages/LegalPage";

export default function CookiesPage() {
  return <LegalPage ns="cookies" sections={["s1","s2","s3","s4","s5","s6","s7"]} />;
}
